import TemplateView from '../../../TemplateView'
import LoadingContainer from "../../../util/LoadingContainer"
import $ from "jquery"
import AssignedUsersEditorContainer from "../../../panels/usersAssignedToHierarchy/AssignedUsersEditorContainer"
import TabHeaders from "../TabHeaders"
import messageResource from "../../../messageResource"
import {addDefaultUserGroup} from "../../../util/groupUtils"
import AssignedUsersEditor from "../../../panels/usersAssignedToHierarchy/AssignedUsersEditor"
import AssignedUsersEditorChangesHandler from "../AssignedUsersEditorChangesHandler"
import ProxyView from "../../../util/ProxyView"
import TabsController from '../../../panels/TabsController'
import CopySettingsBlock from '../../../panels/components/CopySettingsBlock'
import InformationBlock from '../../../components/informationBlock/InformationBlock'
import {getItemsForCopyProjectSettingsBlock} from '../../../panels/components/utils'
import {Feature} from '../../../features'
import {isEnabled} from '../../../features/utils'
import {EntityTextLimits} from 'constants'
import {hasSomeTeamAssignment} from '../../../util/accessRightsUtils'
import {Description} from '../../../panels/Description'
import CPCombobox from '../../components/CPCombobox'

const TAB_KEYS = {
    DETAILS: 'details',
    ASSIGNED_USERS: 'assignedUsers',
    MANAGERS: 'managers'
};

export default class Content extends TemplateView {
    constructor({
            customerInfos,
            enabledFeatures,
            assignedUsersData,
            assignedUsersDataForManagers,
            canManageAccountsAndPermissions,
            hasSomeTeamAssignment,
        },
        {
            onChangeNameCb = () => {},
            onBlurNameCb = () => {},
            onNameKeyUpCb = () => {},
            onNameKeyPressCb = () => {},
            onChangeCustomerSelectorCb = () => {},
            onChangeDescriptionCb = () => {},
            onChangeCb = () => {},
            refreshScrollCb = () => {},
            scrollToSelectorCb = () => {},
        }) {
        super(null)

        this.params = {
            customerInfos,
            enabledFeatures,
            assignedUsersData,
            assignedUsersDataForManagers,
            canManageAccountsAndPermissions,
            hasSomeTeamAssignment,
        }

        this.callbacks = {
            onChangeNameCb,
            onBlurNameCb,
            onNameKeyUpCb,
            onNameKeyPressCb,
            onChangeCustomerSelectorCb,
            onChangeDescriptionCb,
            onChangeCb,
            refreshScrollCb,
            scrollToSelectorCb,
        }

        this.updateOnInit = true

        this.state = {
            currentTabKey: null,
            selectedCustomerId: -1,
        }
        this.onStatePropertyChanged('currentTabKey', this._handleTabSwitched)

        this.onStatePropertyChanged('selectedCustomerId', (id) => {
            this.$importSettings.toggle(id !== -1)
            this.callbacks.refreshScrollCb()
            this.customersSelector.setState({selectedItemId: id})
            this.callbacks.onChangeCustomerSelectorCb()
        })
    }

    templateModel() {
        return {
            id: 'customerLightBox',
            maxNameLength: EntityTextLimits.MAX_CPT_NAME,
        }
    }

    messageKeys() {
        return {
            customerNamePlaceholder: 'customer.edit.name.placeholder.text',
            emptyNameErr: 'customer.error.name_required',
            duplicateNameErr: 'customer.edit.error.name_duplicate',
            descriptionTitle: 'common.description',
            createFromExistsCaption: 'customer.create.import_from_existing_customer.caption'
        }
    }

    templateHtml() {
        return '<div class="innerContent">' +
               '    <div class="customerInfoDiv">' +
               '        <div class="customerNameDiv">' +
               '            <input type="text" class="inputFieldWithPlaceholder newNameField inputNameField" placeholder="<%-customerNamePlaceholder%>" maxlength="<%=maxNameLength%>" autocomplete="off">' +
               '            <div class="nameEmptyError inlineErrorMessage leftInlineErrorMessage"><%-emptyNameErr%></div>' +
               '            <div class="nameDuplicateError inlineErrorMessage leftInlineErrorMessage"><%-duplicateNameErr%></div>' +
               '        </div>' +
               '' +
               '        <div class="descriptionSection section">' +
               '           <div class="title sectionHeader"><%-descriptionTitle%></div>' +
               '           <div class="description"></div>' +
               '        </div>' +
               '' +
               '        <div class="customerImportDiv">' +
               '            <div class="customerImportDivTitle" class="formblocktitle">' +
               '                <%-createFromExistsCaption%>' +
               '            </div>' +
               '            <div>' +
               '                <span class="customerSelectorPlaceholder selectorWithPlaceholderContainer"></span>' +
               '            </div>' +
               '            <div class="customerImportSettingsDiv">' +
               '            </div>' +
               '        </div>' +
               '    </div>' +
               '</div>'
    }


    afterRender() {
        this.customerInfoDiv = this.find(".customerInfoDiv")[0];
        this.$customerImportDiv = this.find(".customerImportDiv")
        this.$importSettings = this.find(".customerImportSettingsDiv")

        this.initNameField();
        this.initDescriptionField();

        this.$customerSelectorPlaceHolder = this.find(".customerSelectorPlaceholder");
        this.initCustomerSelector(this.params.customerInfos);
        this.initImportSettings();

        this.initPlaceholders();

        const tabHeaders = new TabHeaders().init($("<div></div>").insertBefore(this.$el.parent().parent())); // TODO temporary. Move to header

        const assignedUsersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.assignedUsersEditorChangesHandler.handleUserDelete(userData.id),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.assignedUsersEditorChangesHandler.handleAssignedUsersChange(addedUserIds,
                    removedUserIds),
                titleMessageKey: "assigned_users_editor.customer.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.customer.has_all_assignments")
                    }
                },
                managersMessageKey: "assigned_users_editor.customer.managers_count",
                canEditManagers: false,
                addUsersMessageKey: "assigned_users_editor.add_title",
                emptyListMessageKey: "assigned_users_editor.customer.empty_list",
                showPermissionIcons: false,
                checkIfCanModify: user => !user.hasManageAssignment,
                getListDisabledTooltipText: user => this._getDisabledTooltipText(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipText(user),
                renderUserSelectorToContent: true,
                refreshScrollCb: this.callbacks.refreshScrollCb,
            }),
            containerClass: "assignedUsersTab"
        }).init(this.$el);
        this.assignedUsersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: assignedUsersEditor,
            $tabTitle: tabHeaders.$assignedUsersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
        }).init();
        this.assignedUsersEditorChangesHandler = new AssignedUsersEditorChangesHandler({
            editor: this.assignedUsersEditorContainer,
            assignedUserModelExtender: assigned => ({hasCustomerAssignment: assigned}),
            changeCallback: () => this.callbacks.onChangeCb(),
        })

        const managersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.managersEditorChangesHandler.handleUserDelete(userData.id),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.managersEditorChangesHandler.handleAssignedUsersChange(addedUserIds,
                    removedUserIds),
                titleMessageKey: "assigned_users_editor.managers.customer.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.managers.customer.has_all_assignments")
                    }
                },
                addUsersMessageKey: "assigned_users_editor.managers.add_title",
                showPermissionIcons: true,
                checkIfCanModify: user => !user.hasManageAssignment,
                getListDisabledTooltipText: user => this._getDisabledTooltipText(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipText(user),
                renderUserSelectorToContent: true,
                refreshScrollCb: this.callbacks.refreshScrollCb,
            }),
            containerClass: "managersTab"
        }).init(this.$el);
        managersEditor.setState({
            isBTYEnabled: isEnabled(this.params.enabledFeatures, Feature.BTY),
            isURAEnabled: isEnabled(this.params.enabledFeatures, Feature.URA),
            isTTAEnabled: isEnabled(this.params.enabledFeatures, Feature.TTA),
        })

        this.managersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: managersEditor,
            $tabTitle: tabHeaders.$managersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
        }).init();
        this.managersEditorChangesHandler = new AssignedUsersEditorChangesHandler({
            editor: this.managersEditorContainer,
            assignedUserModelExtender: assigned => ({hasCustomerAssignment: assigned}),
            changeCallback: () => this.callbacks.onChangeCb(),
        })

        let tabs = new Map([
            [TAB_KEYS.DETAILS, new ProxyView($(".customerInfoDiv"))],
            [TAB_KEYS.ASSIGNED_USERS, assignedUsersEditor],
            [TAB_KEYS.MANAGERS, managersEditor]
        ])

        tabs.forEach(($tab, tabKey) => {
            $tab.hide()
        })

        this.tabsController = new TabsController({
            tabs: tabs,
        }).init()

        this.buttons = new Map([
            [TAB_KEYS.DETAILS, tabHeaders.$detailsTabHeader],
            [TAB_KEYS.ASSIGNED_USERS, tabHeaders.$assignedUsersTabHeader],
            [TAB_KEYS.MANAGERS, tabHeaders.$managersTabHeader]
        ])

        this.buttons.forEach(($button, key) => {
            $button.click(() => {
                this.openTabByKey(key)
            })
        })

        if (isEnabled(this.params.enabledFeatures, Feature.WAS)) {
            this.assignedUsersEditorContainer.setState({
                userGroupsEnabled: this.params.assignedUsersData.userGroupsEnabled,
                timeZoneGroupsEnabled: this.params.assignedUsersData.timeZoneGroupsEnabled,
                users: this.params.assignedUsersData.users,
                userGroups: (this.params.assignedUsersData.userGroups) ? addDefaultUserGroup(
                    this.params.assignedUsersData.userGroups) : this.params.assignedUsersData.userGroups,
                timeZoneGroups: this.params.assignedUsersData.timeZoneGroups,
                canModifyAny: this.params.assignedUsersData.canModifyAny
            });
        } else {
            this.buttons.get(TAB_KEYS.ASSIGNED_USERS).hide()
        }

        this.managersEditorContainer.setState({
            userGroupsEnabled: this.params.assignedUsersDataForManagers.userGroupsEnabled,
            timeZoneGroupsEnabled: this.params.assignedUsersDataForManagers.timeZoneGroupsEnabled,
            users: this.params.assignedUsersDataForManagers.users,
            userGroups: (this.params.assignedUsersDataForManagers.userGroups) ? addDefaultUserGroup(
                this.params.assignedUsersDataForManagers.userGroups) : this.params.assignedUsersDataForManagers.userGroups,
            timeZoneGroups: this.params.assignedUsersDataForManagers.timeZoneGroups,
            canModifyAny: this.params.assignedUsersDataForManagers.canModifyAny,
            hideAssignButton: !this.params.assignedUsersDataForManagers.canModifyAny
        });
    }

    update() {
        this.openTabByKey(TAB_KEYS.DETAILS)
    }

    openTabByKey(key) {
        this.setState({currentTabKey: key})
    }

    _handleTabSwitched = (selectedKey, previousKey) => {
        this.tabsController.setState({selectedTabKey: selectedKey})

        if (previousKey) this.buttons.get(previousKey).toggleClass('selected', false)
        this.buttons.get(selectedKey).toggleClass('selected', true)
    }

    _getDisabledTooltipText(user) {
        let msg = messageResource.getMessage(
            'assigned_users_editor.managers.disabled_tooltip',
            [
                messageResource.getMessage('common.customer'),
                user.firstName,
            ]
        )
        msg += " " + messageResource.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope')
        return msg
    }

    getData() {
        return [
            this.getCustomerName(),
            this.getDescription(),
            this.state.selectedCustomerId,
            this.copySettingsBlock.getSelectedSettings(),
            this.assignedUsersEditorChangesHandler.getAddedUserIds(),
            this.managersEditorChangesHandler.getAddedUserIds()
        ]
    }

    initNameField() {
        this.nameField = this.find(".newNameField");

        this.nameField.off();
        this.nameField.blur(() => this.callbacks.onBlurNameCb(this.nameField));
        this.nameField.keyup(() => this.callbacks.onNameKeyUpCb(this.nameField));
        this.nameField.change(() => this.callbacks.onChangeNameCb(this.nameField));
        this.nameField.keydown(() => this.callbacks.onNameKeyPressCb(this.nameField));
    }

    initPlaceholders() {
        this.nameField.placeholder();
    }

    getNameField() {
        return this.nameField
    }

    getCustomerName() {
        return this.nameField.pVal();
    }

    initDescriptionField() {
        this.$description = this.find(".descriptionSection .description");
        this.description = new Description({
            onChange: (description) => {
                this.description.setState({
                    text: description,
                })
                this.callbacks.onChangeDescriptionCb(description)
            },
        }).init(this.$description)

        this.description.setState({
            placeholder: messageResource.getMessage("customer.edit.description.placeholder.text"),
            editable: true,
        })
    }

    getDescription() {
        return this.description.getText();
    }

    getCustomerSelectorList() {
        return this.customersSelector.getMenuEl()
    }

    initCustomerSelector(customerInfos) {
        const initialValue = {id: -1, name: messageResource.getEscapedMessage("task.list.move_to.select_customer")}

        const items = [];
        items.push(...customerInfos)

        this.$customerSelectorPlaceHolder.empty()

        this.customersSelector = new CPCombobox({
            emptySelectionMessageKey: "task.list.move_to.select_customer",
            notFoundMessageKey: "task.list.move_to.no_customers_found",
            hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_customers',
            hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_customers',
            emptyListMessageKey: "task.list.move_to.no_customers",
            onItemSelectedCb: (item) => {
                this.setState({
                    selectedCustomerId: item.id,
                })
            },
            onListShowCb: () => {
                this.$customerImportDiv.addClass('withCustomerSelector')
                this.callbacks.scrollToSelectorCb()
                this.callbacks.refreshScrollCb()
            },
            onListHideCb: () => {
                this.$customerImportDiv.removeClass('withCustomerSelector')
                this.callbacks.refreshScrollCb()
            },
            positionParams: {
                within: this.getEl(),
            }
        }).init($(this.$customerSelectorPlaceHolder))
        this.customersSelector.setState({
            additionalItems: [initialValue],
            items: items,
        })
    }

    initImportSettings() {
        const $importSettings = this.find(".customerImportSettingsDiv")

        const enabledFeatures = this.params.enabledFeatures
        const wasEnabled = isEnabled(enabledFeatures, Feature.WAS)

        this.copySettingsBlock = new CopySettingsBlock({
            additionalClass: 'copyProject',
            ...getItemsForCopyProjectSettingsBlock(
                this.params.canManageAccountsAndPermissions,
                isEnabled(enabledFeatures, Feature.BTY),
                isEnabled(enabledFeatures, Feature.EST),
                isEnabled(enabledFeatures, Feature.TWS),
                wasEnabled,
                this.params.hasSomeTeamAssignment
            ),
        }).init(this.$importSettings)

        new InformationBlock({
            paragraphs: [
                messageResource.getMessage(wasEnabled ? 'customer.create.copy_assignments_info' : 'customer.create.copy_assignments_info_was_off'),
            ],
        }).init(this.$importSettings)
    }

    setErrorClasses(classes) {
        this.find('.customerInfoDiv').removeClass().addClass(classes.join(' ')).addClass('customerInfoDiv')
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/customer/Content.js